import Component from 'D:/AUTOMFL/UniApp/uniAdmin/components/fix-window/fix-window.vue'
wx.createComponent(Component)